import React, { useState, useEffect } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Box,
  ListSubheader,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const SchoolsDropdownById = ({ schools, value, onChange }) => {
  const theme = useTheme();
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSchools, setFilteredSchools] = useState([]);
  const [selectValue, setSelectValue] = useState(value ? value.school_id : "");

  useEffect(() => {
    setSelectValue(value ? value.school_id : "");
  }, [value]);

  const handleChange = (event) => {
    setSelectValue(event.target.value);
    const selectedSchool = schools.find(
      (school) => school.school_id === event.target.value
    );
    onChange(selectedSchool);
  };

  const handleSearchChange = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
  };

  useEffect(() => {
    // Ensure schools is an array before proceeding
    if (!Array.isArray(schools)) {
      setFilteredSchools([]);
      return;
    }

    if (searchTerm.trim() === "") {
      setFilteredSchools(schools); // Show all schools if search is empty
    } else {
      const lowerSearchTerm = searchTerm.toLowerCase();
      const results = schools.filter(
        (school) =>
          // Defensive: ensure school_name exists and is a string
          typeof school.school_name === "string" &&
          school.school_name.toLowerCase().includes(lowerSearchTerm)
      );
      setFilteredSchools(results);
    }
  }, [searchTerm, schools]);

  return (
    <FormControl fullWidth margin="dense">
      <InputLabel>School</InputLabel>
      <Select
        value={selectValue}
        onChange={handleChange}
        label="School"
        renderValue={(selected) => {
          if (!schools) return ""; // Check if schools is still loading
          const selectedSchool = schools.find(
            (school) => school.school_id === selected
          );
          return selectedSchool ? selectedSchool.school_name : "";
        }}
      >
        <ListSubheader
          sx={{
            p: 1, // Add padding to the ListSubheader itself
            backgroundColor: theme.palette.background.paper, // Use the theme's paper background color
            position: "sticky", // Make the subheader sticky
            top: 0, // Stick to the top
            zIndex: 1, // Ensure it's above scrolling menu items
          }}
        >
          <Box
            sx={{ outline: "none" }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              // Allow key events to propagate for typing, but stop if it's Enter/Escape that Select might interpret
              // This specific onKeyDown might need fine-tuning based on behavior
              if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                // Example: let TextField handle most keys
                e.stopPropagation();
              }
            }}
          >
            <TextField
              fullWidth
              size="small"
              placeholder="Search Schools"
              value={searchTerm}
              onChange={handleSearchChange}
              autoFocus // Auto-focus the search field
              onClick={(e) => e.stopPropagation()} // Also stop propagation on the TextField itself
              onMouseDown={(e) => e.stopPropagation()} // Also stop propagation on the TextField itself
            />
          </Box>
        </ListSubheader>
        {filteredSchools.map((school) => (
          <MenuItem key={school.school_id} value={school.school_id}>
            {school.school_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SchoolsDropdownById;
